import { styled } from '@mui/system'
import { colors } from '../../Components/consts'

export const InnerCon = styled('div')(({ theme }) => ({
  minHeight: '100vh',
      '& .tableCon': {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
            overflowX: 'scroll',
          },
          '& .selectorCon': {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            alignItems: 'center',
            flexDirection: 'row',
        },
      '& .tableOuter': {
        display: 'flex',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
        overflowX: 'scroll',
      },
      '& .table': {
        borderCollapse: 'collapse',
      [theme.breakpoints.down('sm')]: {
        width: '100vw',
      },
      '& thead': {
        position: 'sticky',
        top: 0,
        zIndex: 20,
        background: colors.white
      },
      '& th': {
        fontSize: 14,
        color: colors.text,
        fontWeight: 'normal',
        textTransform: 'uppercase',
        height: theme.spacing(5),
        textAlign: 'left',
        padding: theme.spacing(0.5),
        [theme.breakpoints.down('sm')]: {
            fontSize: 11
          },
      },
      '& tbody tr': {
        borderTop: `1px solid ${colors.lightGrey}`,
        '&:first-of-type': {
          borderTop: 0,
        },
      },
      '& tbody td': {
        fontSize: 15,
        padding: theme.spacing(1,0.5),
        color: colors.text,
        minWidth: 60,
        textAlign: 'left',
        fontWeight: 400,
        [theme.breakpoints.down('sm')]: {
          fontSize: 10,
          minWidth: 45,
        },
        '&:first-of-type': {
          minWidth: 80,
          textAlign: 'left',
        },
        '& a': {
          color: colors.text,
          textDecoration: 'none',
        },
        '& svg': {
          width: 18,
          marginLeft: theme.spacing(1),
        },
        '&:last-child': {
          minWidth: 250,
          maxWidth: 500,
          textAlign: 'left',
        },
      },
      '& tfoot p': {
        fontWeight: 'normal',
        fontSize: 14
      },
      }

      }
    },
}))

export const ResetBtn = styled('button')(({ theme }) => ({
  border: 'none',
  background: colors.lightestGrey,
  borderRadius: 10,
  cursor: 'pointer',
  marginLeft: 10,
  padding: theme.spacing(2),
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: colors.lightGrey,
  },
}))
